<template>
  <div class="base-display">
    <div
      :class="[
        'base-data',
        baseDataList.length == 3 ? 'base-data-three' : 'base-data-four',
        isPadding == '1' ? 'isPaddingOne' : isPadding == '2' ? 'isPaddingTwo' : '',
        titleName == '点位及人力部署' ? 'analysisDisposal ' : '',
      ]"
    >
      <div v-for="(item, index) in baseDataList" :key="index" class="list">
        <img :src="item.img" class="base-data-img" />
        <div class="name-num">
          <div class="name">{{ item.name }}</div>
          <div class="num">{{ item.num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import titleInternal from "@/pages/patrolScreenMini/components/title-internal.vue";
export default {
  name: "index",
  components: {
    titleInternal,
  },
  props: {
    baseDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isPadding: {
      type: String,
      default: "",
    },
    titleName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.base-display {
  display: flex;
  align-items: center;
  position: relative;
  // margin: 20px 0 0 10px;
  .base-img {
    width: 727px;
    position: absolute;
    top: 26px;
  }
  .base-data {
    display: flex;
    width: 565px;
    padding: 0 20px;
    .list {
      display: flex;
      width: 25%;
      .name-num {
        margin: 0 0 0 12px;
      }
      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 12px;
        color: #adc2d3;
        line-height: 16px;
      }
      .num {
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 17px;
        color: #e4f2ff;
        line-height: 22px;
        margin-top: 4px;
      }
    }
    .base-data-img {
      width: 44px;
      height: 45px;
    }
  }
  .base-data-three {
    margin-top: 24px;
    padding: 0 20px;
    .list {
      width: 33.3%;
    }
  }
  .base-data-four {
    width: 403px;
    flex-wrap: wrap;
    .list {
      width: calc(50% - 20px);
      margin: 16px 0 0 20px;
    }
  }
  .analysisDisposal {
    width: 312px;
    flex-wrap: wrap;
    .list {
      width: 50%;
      margin: 16px 0 0 0;
    }
  }
  
  .isPaddingOne {
    .list {
      width: 28.3%;
    }
    .list:last-child {
      width: 20%;
    }
  }
  .isPaddingTwo {
    padding: 0 0 0 20px;
    .list {
      width: 28.3%;
    }
    .list:last-child {
      width: 20%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/base-displaySpecail.vue